import React from 'react';
import { Group, Text, Tooltip, Stack, Box } from '@mantine/core';
import { IconInfoCircle } from '@tabler/icons-react';
import { CateringEventVendorDetailsUpcoming } from '../types';
import { cateringUpcomingChecklist } from './config';

export const CateringUpcomingChecklist: React.FC<{ event: CateringEventVendorDetailsUpcoming }> = ({
  event,
}) => {
  const eventDetails = event.event;
  const checklist = cateringUpcomingChecklist.map((listItem) => {
    let listItemValue = eventDetails[listItem.key as keyof typeof eventDetails];
    if (listItem.boolean) {
      listItemValue = listItemValue ? 'Yes' : 'No';
    }
    return {
      label: listItem.label,
      text: listItemValue,
    };
  });
  return (
    <Box bd="1px solid var(--mantine-color-gray-4)" p="sm" bdrs="md">
      <Group gap="sm" mb="xs">
        <Text fw="bold">Event Checklist</Text>
        <Tooltip
          multiline
          withArrow
          w={260}
          position="bottom"
          transitionProps={{ transition: 'fade-down', duration: 200 }}
          label="Please refer to the Purchase Order and Packing Slip for full event information."
        >
          <IconInfoCircle size={18} color="var(--mantine-color-blue-4)" />
        </Tooltip>
      </Group>
      <Stack gap="sm">
        {checklist.map((item) => (
          <Group key={item.label} gap="xs">
            <Text>{item.label}:</Text>
            <Text>{item.text}</Text>
          </Group>
        ))}
      </Stack>
    </Box>
  );
};
